import {OTAssetKeys} from '../contexts/types/ot-asset-row-types'

export type ColumnsMapping = Record<OTAssetKeys, string | null>
export type ColumnMappingView = 'all' | 'required' | 'optional' | 'unmapped'

export const COLUMN_MAPPING_DEFAULT_VALUE = Object.values(OTAssetKeys).reduce((acc, key) => {
    acc[key] = null
    return acc
}, {} as ColumnsMapping)
